<app-error-message [errorMessageSource]="errorMessageSource"></app-error-message>
<div class="ti-form-wrapper">
  <div class="ti-progress-detectors">
    <h1>{{ (isNew ? 'lexicon.lexeme-creation' : 'lexicon.lexeme-edit') | translate}}</h1>
    <mat-progress-bar *ngIf="showSpinner" color="accent" mode="indeterminate"></mat-progress-bar>
  </div>
  <form class="ti-form" *ngIf="lexeme && form" [formGroup]="form">
    <div *ngIf="lexeme.id" class="ti-form__id"><span class="ti-form__id-key">ID</span> <span class="ti-form__id-value">{{lexeme.id}}</span>
    </div>
    <mat-form-field color="accent">
      <input
        matInput
        name="lemma"
        [required]="true"
        (keydown)="clearTheErrorMessage()"
        appDisableControl
        [disableControl]="!doesUserHaveAccessToEdit"
        [(ngModel)]="lexeme.lemma"
        formControlName="lemma"
        [style.text-align]="textAlignStyle()"
        style="line-height: 150%;"
        [lang]="languageISOCode()"
        spellcheck="true"
        [dir]="languageDir()"
        (change)="prepareMWESettings()"
        [placeholder]="'COMMON.main-lemma' | translate"/>
    </mat-form-field>
    <div class="ti-form__one-line-fields" *ngIf="!lexeme.invariable && mweSegments && mweSegments.length &gt; 0">
      <label class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.head-segment' | translate}}</label>
      <ng5-slider [(value)]="lexeme.inflectingSegment" [options]="inflectingSegmentSliderDefinition"></ng5-slider>
    </div>
    <div class="ti-form__one-line-fields" *ngIf="!lexeme.invariable && mweSegments && mweSegments.length &gt; 0 && lexeme.inflectingSegment &gt; 0">
      <label class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.agreeing-range' | translate}}</label>
      <ng5-slider [(value)]="lexeme.agreeingSegment1st" [(highValue)]="lexeme.agreeingSegmentLast" [options]="agreementSliderDefinition"></ng5-slider>
    </div>

    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.stem' | translate}}</p>
      <p>{{lexeme.stem}}</p>
    </div>
    <mat-checkbox
      class="ti-form__column ti-form__one-line-fields--with-checkbox"
      matInput
      name="invariable"
      [(ngModel)]="lexeme.invariable"
      (change)="clearTheErrorMessage()"
      formControlName="invariable">
      <span class="ti-form__label">{{'lexicon.invariable' | translate}}</span>
    </mat-checkbox>
    <div *ngIf="!isNew" class="ti-form__button-panel">
      <button mat-stroked-button color="accent"
              appDoYouSaveDialog
              [isObjectChanged]="isObjectChanged()"
              (dialogWasClosedEvent)="reactOnDoYouSaveDialogClosed($event)"
              (click)="clearTheErrorMessage()">{{'lexicon.inflections' | translate}}
        <!--open dialog with inflections-->
      </button>
      <button
        mat-stroked-button
        color="accent"
        [disabled]="showSpinner"
        (click)="clearTheErrorMessage();reactOnTagClick()">{{'COMMON.tag' | translate}}
      </button>
      <button
        mat-button
        color="primary"
        [disabled]="(!tagging)"
        (click)="clearTheErrorMessage()"
        class="ti-link-underline-text-decoration ti-link-button ti-blue-link"
        appOpenInflectionMatchedDialog
        [tagging]="tagging"
        [lexeme]="lexeme.lemma"
      >
        {{'lexicon.tag-trace' | translate}}
      </button>
    </div>

    <div class="ti-form__bordered-part">
      <span class="ti-form-bordered-part__label">{{'COMMON.features' | translate}}</span>

      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'COMMON.grammar' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features
            *ngIf="relevantGrammarFeatureList"
            [featureValues]="lexeme.grammar"
            [doesTheWholeFeatureListRelevant]="dontFilterGrammar"
            [relevantFeatureList]="relevantGrammarFeatureList"
            [isOnlyOneFeature]="false"
            (featuresUpdatedValueEvent)="disableTagTrace($event)"
          ></app-universal-features>
        </div>
      </div>
      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'lexicon.style' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features
            *ngIf="relevantStyleFeatureList"
            [featureValues]="lexeme.style"
            [doesTheWholeFeatureListRelevant]="true"
            [relevantFeatureList]="relevantStyleFeatureList"
            [isOnlyOneFeature]="false"
            (featuresUpdatedValueEvent)="disableTagTrace($event)"
          >
          </app-universal-features>
        </div>
      </div>
      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'COMMON.semantic' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features
            *ngIf="relevantStyleFeatureList"
            [featureValues]="lexeme.semantics"
            [doesTheWholeFeatureListRelevant]="true"
            [relevantFeatureList]="semanticFeatureList"
            [isOnlyOneFeature]="false"
            (featuresUpdatedValueEvent)="disableTagTrace($event)"
          >
          </app-universal-features>
        </div>
      </div>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.root' | translate}}</p>
      <p class="ti-form__root-description">{{lexeme.rootDescription}}</p>
      <div class="ti-form__button-panel ti-root-buttons">
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          appRootLookupButtonDirective
          (selectedDataEvent)="selectRoot(1, $event)"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage();selectRoot(1);"
          style="margin-left: 10px"
          [disabled]="!lexeme.root"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.root' | translate}}2</p>
      <p class="ti-form__root-description">{{lexeme.root2Description}}</p>

      <div class="ti-form__button-panel ti-root-buttons">
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          appRootLookupButtonDirective
          (selectedDataEvent)="selectRoot(2, $event)"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage();selectRoot(2)"
          style="margin-left: 10px"
          [disabled]="!lexeme.root2"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.root' | translate}}3</p>
      <p class="ti-form__root-description">{{lexeme.root3Description}}</p>
      <div class="ti-form__button-panel ti-root-buttons">
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          appRootLookupButtonDirective
          (selectedDataEvent)="selectRoot(3, $event)"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage();selectRoot(3)"
          style="margin-left: 10px"
          [disabled]="!lexeme.root3"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.root' | translate}}4</p>
      <p class="ti-form__root-description">{{lexeme.root4Description}}</p>
      <div class="ti-form__button-panel ti-root-buttons">
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          appRootLookupButtonDirective
          (selectedDataEvent)="selectRoot(4, $event)"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage();selectRoot(4);"
          style="margin-left: 10px"
          [disabled]="!lexeme.root4"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>

    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__column--label-for-radio-buttons">{{'lexicon.multiword-expression-behavior' |
        translate}}:</p>
      <mat-radio-group [(ngModel)]="lexeme.mweBehavior" formControlName="mweBehavior">
        <mat-radio-button
          class="ti-form__radio-button"
          *ngFor="let option of mweBehaviorOptions"
          value="{{option.key}}">{{option.value}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="ti-form__one-line-fields ti-advanced-criteria__wrap">
      <p class="ti-form__label ti-form__form-attribute-value-field">
        {{ 'COMMON.advanced-criteria' | translate}}
      </p>
      <p class="ti-advanced-criteria__description" *ngIf="lexeme.advancedCriteriaDescription">
        {{lexeme.advancedCriteriaDescription}}
      </p>
      <div class="ti-advanced-criteria__buttons">
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          appAdvancedCriteriaButton
          [forWords]="true"
          [dialogTitle]="'lexemes'"
          (selectedDataEvent)="reactOnSelectedAdvancedCriteria($event)"
          style="margin-left: 10px"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>

        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          [disabled]="!lexeme.advancedCriteriaId"
          appAdvancedCriteriaOpenEditDialog
          [forWords]="true"
          (updateDataEvent)="reactOnUpdateAdvancedCriteria()"
          [isEdit]="true"
          [currentId]="lexeme.advancedCriteriaId"
        >
          <mat-icon aria-hidden="true">edit</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearTheErrorMessage();clearAdvancedCriteria();"
          style="margin-left: 10px"
          [disabled]="!lexeme.advancedCriteriaDescription"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>


    <div class="ti-form__one-line-fields ti-advanced-criteria__wrap">
      <p class="ti-form__label ti-form__form-attribute-value-field">
        {{ 'COMMON.master-lexeme' | translate}}
      </p>
      <p class="ti-advanced-criteria__description" *ngIf="_masterLexemeDescription">
        {{_masterLexemeDescription}}
      </p>
      <div class="ti-advanced-criteria__buttons">
        <button
          mat-mini-fab
          color="primary"
          appOpenKnowledgeGraphDialog
          (afterDialogClosedEvent)="setSameAsLexeme($event)"
          [isLexemesDialog]="true"
          [allowOtherLanguages]="true"
          [isFamilyDialog]="false"
          [familyId]="lexeme.sameFamiliesAs"
          [chooseOnlyOneItem]="true"
          style="margin-left: 10px"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearMasterLexeme();"
          style="margin-left: 10px"
          [disabled]="!_masterLexemeDescription"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>

    <div class="ti-form__one-line-fields ti-advanced-criteria__wrap">
      <p class="ti-form__label ti-form__form-attribute-value-field">
        {{ 'COMMON.same-inflections-as' | translate}}
      </p>
      <p class="ti-advanced-criteria__description" *ngIf="_inflectionSourceLexemeDescription">
        {{_inflectionSourceLexemeDescription}}
      </p>
      <div class="ti-advanced-criteria__buttons">
        <button
          mat-mini-fab
          color="primary"
          appOpenKnowledgeGraphDialog
          (afterDialogClosedEvent)="setSameInflectionsAs($event)"
          [isLexemesDialog]="true"
          [allowOtherLanguages]="true"
          [isFamilyDialog]="false"
          [chooseOnlyOneItem]="true"
          [familyId]="lexeme.sameInflectionsAs"
          style="margin-left: 10px"
        >
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button
          mat-mini-fab
          color="primary"
          (click)="clearSameInflectionsAs();"
          style="margin-left: 10px"
          [disabled]="!_inflectionSourceLexemeDescription"
        >
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>

    <div class="ti-form__one-line-fields ti-advanced-criteria__wrap">
      <p class="ti-form__label ti-form__form-attribute-value-field">
        {{ 'COMMON.same-style-as' | translate}}
      </p>
      <p class="ti-advanced-criteria__description" *ngIf="_sameStyleAsDescription">
        {{_sameStyleAsDescription}}
      </p>
      <div class="ti-advanced-criteria__buttons">
        <button mat-mini-fab color="primary" appOpenKnowledgeGraphDialog (afterDialogClosedEvent)="setSameStyleAs($event)"
          [isLexemesDialog]="true" [allowOtherLanguages]="true" [isFamilyDialog]="false" [chooseOnlyOneItem]="true"
          [familyId]="lexeme.sameStyleAs" style="margin-left: 10px">
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
        <button mat-mini-fab color="primary" (click)="clearSameStyleAs();" style="margin-left: 10px"
          [disabled]="!_sameStyleAsDescription">
          <mat-icon aria-hidden="true">clear</mat-icon>
        </button>
      </div>
    </div>


    <mat-form-field color="accent">
      <input
        matInput
        name="frequency"
        (keydown)="clearTheErrorMessage()"
        appDisableControl
        [disableControl]="!doesUserHaveAccessToEdit"
        [(ngModel)]="lexeme.frequency"
        formControlName="frequency"
        [matTooltip]="'COMMON.frequency-grade-tooltip' | translate"
        [placeholder]="'COMMON.frequency-grade' | translate"/>
    </mat-form-field>
    <mat-form-field color="accent">
      <input
        matInput
        [matDatepicker]="picker"
        [placeholder]="'advanced-family-edit.earliest-mention' | translate"
        name="earliestMention"
        appDisableControl
        [max]="maxDate"
        formControlName="earliestMention"
        [disableControl]="!doesUserHaveAccessToEdit"
        [(ngModel)]="earliestMention"
      >
      <mat-datepicker-toggle color="accent" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker startView="year" color="accent"></mat-datepicker>
    </mat-form-field>
    <mat-form-field color="accent">
      <input
        matInput
        name="lastYearActive"
        (keydown)="clearTheErrorMessage()"
        appDisableControl
        [disableControl]="!doesUserHaveAccessToEdit"
        [matTooltip]="'advanced-family-edit.last-year-active-tooltip' | translate"
        [(ngModel)]="lexeme.lastYearActive"
        formControlName="lastYearActive"
        [placeholder]="'advanced-family-edit.last-year-active' | translate"/>
    </mat-form-field>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.legacy-inflection-map-id' |
        translate}}</p>
      <p>{{lexeme.legacyInflectionMapId}}</p>
    </div>
    <mat-form-field color="accent">
      <textarea
        matInput
        [style.text-align]="textAlignStyle()"
        [lang]="languageISOCode()"
        [dir]="languageDir()"
        spellcheck="true"
        (change)="clearTheErrorMessage()"
        formControlName="note"
        name="note" [(ngModel)]="lexeme.note"
        [placeholder]="'COMMON.note' | translate"></textarea></mat-form-field>
    <div class="ti-form__one-line-fields" *ngIf="!isNew || (isNew && isAdmin())">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{'commonsense-cues.approval-status' | translate}}</p>
      <mat-form-field class="ti-clause__select">
        <mat-select role="listbox" [(value)]="lexeme.unverified" [disabled]="!doesUserHaveAccessToEdit">
          <mat-option [value]="0">{{'lexicon.approved' | translate}}</mat-option>
          <mat-option [value]="1">{{'lexicon.failed-auto-check' | translate}}</mat-option>
          <mat-option [value]="2">{{'lexicon.auto-generated' | translate}}</mat-option>
          <mat-option [value]="3">{{'lexicon.human-factor' | translate}}</mat-option>
          <mat-option [value]="4">{{'lexicon.auto-grammar' | translate}}</mat-option>
          <mat-option [value]="5">{{'lexicon.auto-style' | translate}}</mat-option>
          <mat-option [value]="6">{{'lexicon.health-check' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="ti-form__id" *ngIf="lexeme.sourceType">
      <span class="ti-form__id-key">{{ 'COMMON.source' | translate}}</span>&nbsp;&nbsp;
      <span class="ti-form__id-value">{{lexeme.sourceType}}&nbsp;({{lexeme.sourceId}}</span>)
    </div>
    <div class="ti-form__id" *ngIf="lexeme.created">
      <span class="ti-form__id-key">{{ 'COMMON.created' | translate}}</span>&nbsp;&nbsp;
      <span class="ti-form__id-value">{{lexeme.created}}&nbsp;({{lexeme.createdBy}}</span>)
    </div>
    <div class="ti-form__id" *ngIf="lexeme.lastUpdate">
      <span class="ti-form__id-key">{{ 'COMMON.last-update' | translate}}</span>&nbsp;&nbsp;
      <span class="ti-form__id-value">{{lexeme.lastUpdate}}&nbsp;({{lexeme.lastUpdatedBy}}</span>)
    </div>
    <div class="ti-form__id" *ngIf="lexeme.lastBatchUpdate">
      <span class="ti-form__id-key">{{ 'COMMON.last-batch-update' | translate}}</span>&nbsp;&nbsp;
      <span class="ti-form__id-value">{{lexeme.lastBatchUpdate}}&nbsp;({{lexeme.lastUpdatedByBatch}}</span>)
    </div>
    <div class="ti-form__button-panel">
      <button mat-raised-button (click)="cancel()">{{'COMMON.cancel' | translate}}</button>
      <button
        [disabled]="!doesUserHaveAccessToEdit"
        mat-raised-button
        color="accent"
        (click)="save()">{{'COMMON.save' | translate}}
      </button>
    </div>
  </form>
  <app-audit-trail
    *ngIf="lexeme && !isNew"
    (assignEvent)="showHistory($event)"
    [tableName]="'Lexemes'"
    [entityId]="lexeme.id">
  </app-audit-trail>
</div>
